const AUTH_RECOVERY_ERROR_CODES = new Set([
  "login_required",
  "consent_required",
  "missing_refresh_token",
  "invalid_grant",
  "invalid_refresh_token",
]);

const AUTH_RECOVERY_MESSAGE_FRAGMENTS = [
  "missing refresh token",
  "login_required",
  "login required",
  "invalid refresh token",
  "invalid_grant",
];

export const isAuthRecoveryError = (error) => {
  const code = String(error?.error || error?.code || "").toLowerCase();
  const message = String(error?.message || "").toLowerCase();

  return (
    AUTH_RECOVERY_ERROR_CODES.has(code) ||
    AUTH_RECOVERY_MESSAGE_FRAGMENTS.some((fragment) => message.includes(fragment))
  );
};

export const buildGuestLoginRedirectOptions = (returnTo) => ({
  authorizationParams: {
    screen_hint: "login",
    prompt: "login",
  },
  appState: {
    returnTo,
  },
});
